export type EmailStatus = 'Verified' | 'NotVerified' | undefined

export const emailStatuses = {
    Verified: 'Verified' as EmailStatus,
    NotVerified: 'NotVerified' as EmailStatus
}